// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_970de1f2",
      load: () => import("#nuxt-i18n/970de1f2" /* webpackChunkName: "locale_en_46json_970de1f2" */),
      cache: true
    },
    {
      key: "locale_en_46json_98999941",
      load: () => import("#nuxt-i18n/98999941" /* webpackChunkName: "locale_en_46json_98999941" */),
      cache: true
    },
    {
      key: "locale_en_46json_45631fb2",
      load: () => import("#nuxt-i18n/45631fb2" /* webpackChunkName: "locale_en_46json_45631fb2" */),
      cache: true
    },
    {
      key: "locale_en_46json_1ee4f0fc",
      load: () => import("#nuxt-i18n/1ee4f0fc" /* webpackChunkName: "locale_en_46json_1ee4f0fc" */),
      cache: true
    },
    {
      key: "locale_en_46json_3010a78a",
      load: () => import("#nuxt-i18n/3010a78a" /* webpackChunkName: "locale_en_46json_3010a78a" */),
      cache: true
    },
    {
      key: "locale_en_46json_f0547b1c",
      load: () => import("#nuxt-i18n/f0547b1c" /* webpackChunkName: "locale_en_46json_f0547b1c" */),
      cache: true
    },
    {
      key: "locale_en_46json_f2782c83",
      load: () => import("#nuxt-i18n/f2782c83" /* webpackChunkName: "locale_en_46json_f2782c83" */),
      cache: true
    },
    {
      key: "locale_en_46json_05c56aef",
      load: () => import("#nuxt-i18n/05c56aef" /* webpackChunkName: "locale_en_46json_05c56aef" */),
      cache: true
    },
    {
      key: "locale_en_46json_1ec625a0",
      load: () => import("#nuxt-i18n/1ec625a0" /* webpackChunkName: "locale_en_46json_1ec625a0" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_dc952246",
      load: () => import("#nuxt-i18n/dc952246" /* webpackChunkName: "locale_fr_46json_dc952246" */),
      cache: true
    },
    {
      key: "locale_fr_46json_0f464d98",
      load: () => import("#nuxt-i18n/0f464d98" /* webpackChunkName: "locale_fr_46json_0f464d98" */),
      cache: true
    },
    {
      key: "locale_fr_46json_52a04b0d",
      load: () => import("#nuxt-i18n/52a04b0d" /* webpackChunkName: "locale_fr_46json_52a04b0d" */),
      cache: true
    },
    {
      key: "locale_fr_46json_8c523e92",
      load: () => import("#nuxt-i18n/8c523e92" /* webpackChunkName: "locale_fr_46json_8c523e92" */),
      cache: true
    },
    {
      key: "locale_fr_46json_6f638c28",
      load: () => import("#nuxt-i18n/6f638c28" /* webpackChunkName: "locale_fr_46json_6f638c28" */),
      cache: true
    },
    {
      key: "locale_fr_46json_36c44e40",
      load: () => import("#nuxt-i18n/36c44e40" /* webpackChunkName: "locale_fr_46json_36c44e40" */),
      cache: true
    },
    {
      key: "locale_fr_46json_360126db",
      load: () => import("#nuxt-i18n/360126db" /* webpackChunkName: "locale_fr_46json_360126db" */),
      cache: true
    },
    {
      key: "locale_fr_46json_5f5a6b27",
      load: () => import("#nuxt-i18n/5f5a6b27" /* webpackChunkName: "locale_fr_46json_5f5a6b27" */),
      cache: true
    },
    {
      key: "locale_fr_46json_93391e9c",
      load: () => import("#nuxt-i18n/93391e9c" /* webpackChunkName: "locale_fr_46json_93391e9c" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_751caef5",
      load: () => import("#nuxt-i18n/751caef5" /* webpackChunkName: "locale_nl_46json_751caef5" */),
      cache: true
    },
    {
      key: "locale_nl_46json_7b064166",
      load: () => import("#nuxt-i18n/7b064166" /* webpackChunkName: "locale_nl_46json_7b064166" */),
      cache: true
    },
    {
      key: "locale_nl_46json_a43db021",
      load: () => import("#nuxt-i18n/a43db021" /* webpackChunkName: "locale_nl_46json_a43db021" */),
      cache: true
    },
    {
      key: "locale_nl_46json_79e8d2a3",
      load: () => import("#nuxt-i18n/79e8d2a3" /* webpackChunkName: "locale_nl_46json_79e8d2a3" */),
      cache: true
    },
    {
      key: "locale_nl_46json_759e3dfc",
      load: () => import("#nuxt-i18n/759e3dfc" /* webpackChunkName: "locale_nl_46json_759e3dfc" */),
      cache: true
    },
    {
      key: "locale_nl_46json_2498a562",
      load: () => import("#nuxt-i18n/2498a562" /* webpackChunkName: "locale_nl_46json_2498a562" */),
      cache: true
    },
    {
      key: "locale_nl_46json_fc3bb21c",
      load: () => import("#nuxt-i18n/fc3bb21c" /* webpackChunkName: "locale_nl_46json_fc3bb21c" */),
      cache: true
    },
    {
      key: "locale_nl_46json_335c4fda",
      load: () => import("#nuxt-i18n/335c4fda" /* webpackChunkName: "locale_nl_46json_335c4fda" */),
      cache: true
    },
    {
      key: "locale_nl_46json_671bdfda",
      load: () => import("#nuxt-i18n/671bdfda" /* webpackChunkName: "locale_nl_46json_671bdfda" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_1d962cd4",
      load: () => import("#nuxt-i18n/1d962cd4" /* webpackChunkName: "locale_de_46json_1d962cd4" */),
      cache: true
    },
    {
      key: "locale_de_46json_158023d8",
      load: () => import("#nuxt-i18n/158023d8" /* webpackChunkName: "locale_de_46json_158023d8" */),
      cache: true
    },
    {
      key: "locale_de_46json_27436f08",
      load: () => import("#nuxt-i18n/27436f08" /* webpackChunkName: "locale_de_46json_27436f08" */),
      cache: true
    },
    {
      key: "locale_de_46json_8403917e",
      load: () => import("#nuxt-i18n/8403917e" /* webpackChunkName: "locale_de_46json_8403917e" */),
      cache: true
    },
    {
      key: "locale_de_46json_8159d21d",
      load: () => import("#nuxt-i18n/8159d21d" /* webpackChunkName: "locale_de_46json_8159d21d" */),
      cache: true
    },
    {
      key: "locale_de_46json_378a5ffc",
      load: () => import("#nuxt-i18n/378a5ffc" /* webpackChunkName: "locale_de_46json_378a5ffc" */),
      cache: true
    },
    {
      key: "locale_de_46json_71396dd9",
      load: () => import("#nuxt-i18n/71396dd9" /* webpackChunkName: "locale_de_46json_71396dd9" */),
      cache: true
    },
    {
      key: "locale_de_46json_757550ce",
      load: () => import("#nuxt-i18n/757550ce" /* webpackChunkName: "locale_de_46json_757550ce" */),
      cache: true
    },
    {
      key: "locale_de_46json_bc22203f",
      load: () => import("#nuxt-i18n/bc22203f" /* webpackChunkName: "locale_de_46json_bc22203f" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_914a2a0f",
      load: () => import("#nuxt-i18n/914a2a0f" /* webpackChunkName: "locale_es_46json_914a2a0f" */),
      cache: true
    },
    {
      key: "locale_es_46json_57725597",
      load: () => import("#nuxt-i18n/57725597" /* webpackChunkName: "locale_es_46json_57725597" */),
      cache: true
    },
    {
      key: "locale_es_46json_ff7e6ee4",
      load: () => import("#nuxt-i18n/ff7e6ee4" /* webpackChunkName: "locale_es_46json_ff7e6ee4" */),
      cache: true
    },
    {
      key: "locale_es_46json_6d7baf1d",
      load: () => import("#nuxt-i18n/6d7baf1d" /* webpackChunkName: "locale_es_46json_6d7baf1d" */),
      cache: true
    },
    {
      key: "locale_es_46json_290dc025",
      load: () => import("#nuxt-i18n/290dc025" /* webpackChunkName: "locale_es_46json_290dc025" */),
      cache: true
    },
    {
      key: "locale_es_46json_b8db324e",
      load: () => import("#nuxt-i18n/b8db324e" /* webpackChunkName: "locale_es_46json_b8db324e" */),
      cache: true
    },
    {
      key: "locale_es_46json_9a1ff6d5",
      load: () => import("#nuxt-i18n/9a1ff6d5" /* webpackChunkName: "locale_es_46json_9a1ff6d5" */),
      cache: true
    },
    {
      key: "locale_es_46json_a3af0099",
      load: () => import("#nuxt-i18n/a3af0099" /* webpackChunkName: "locale_es_46json_a3af0099" */),
      cache: true
    },
    {
      key: "locale_es_46json_0aa1e20d",
      load: () => import("#nuxt-i18n/0aa1e20d" /* webpackChunkName: "locale_es_46json_0aa1e20d" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_fe4935c3",
      load: () => import("#nuxt-i18n/fe4935c3" /* webpackChunkName: "locale_it_46json_fe4935c3" */),
      cache: true
    },
    {
      key: "locale_it_46json_a9356f65",
      load: () => import("#nuxt-i18n/a9356f65" /* webpackChunkName: "locale_it_46json_a9356f65" */),
      cache: true
    },
    {
      key: "locale_it_46json_de53089a",
      load: () => import("#nuxt-i18n/de53089a" /* webpackChunkName: "locale_it_46json_de53089a" */),
      cache: true
    },
    {
      key: "locale_it_46json_848519e3",
      load: () => import("#nuxt-i18n/848519e3" /* webpackChunkName: "locale_it_46json_848519e3" */),
      cache: true
    },
    {
      key: "locale_it_46json_8a1e5438",
      load: () => import("#nuxt-i18n/8a1e5438" /* webpackChunkName: "locale_it_46json_8a1e5438" */),
      cache: true
    },
    {
      key: "locale_it_46json_42d53f60",
      load: () => import("#nuxt-i18n/42d53f60" /* webpackChunkName: "locale_it_46json_42d53f60" */),
      cache: true
    },
    {
      key: "locale_it_46json_f151b17b",
      load: () => import("#nuxt-i18n/f151b17b" /* webpackChunkName: "locale_it_46json_f151b17b" */),
      cache: true
    },
    {
      key: "locale_it_46json_9b77f096",
      load: () => import("#nuxt-i18n/9b77f096" /* webpackChunkName: "locale_it_46json_9b77f096" */),
      cache: true
    },
    {
      key: "locale_it_46json_6809d850",
      load: () => import("#nuxt-i18n/6809d850" /* webpackChunkName: "locale_it_46json_6809d850" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_8605db49",
      load: () => import("#nuxt-i18n/8605db49" /* webpackChunkName: "locale_pl_46json_8605db49" */),
      cache: true
    },
    {
      key: "locale_pl_46json_acf5dac8",
      load: () => import("#nuxt-i18n/acf5dac8" /* webpackChunkName: "locale_pl_46json_acf5dac8" */),
      cache: true
    },
    {
      key: "locale_pl_46json_2a4fb8c9",
      load: () => import("#nuxt-i18n/2a4fb8c9" /* webpackChunkName: "locale_pl_46json_2a4fb8c9" */),
      cache: true
    },
    {
      key: "locale_pl_46json_2877b41e",
      load: () => import("#nuxt-i18n/2877b41e" /* webpackChunkName: "locale_pl_46json_2877b41e" */),
      cache: true
    },
    {
      key: "locale_pl_46json_28d38387",
      load: () => import("#nuxt-i18n/28d38387" /* webpackChunkName: "locale_pl_46json_28d38387" */),
      cache: true
    },
    {
      key: "locale_pl_46json_d0dd8d2f",
      load: () => import("#nuxt-i18n/d0dd8d2f" /* webpackChunkName: "locale_pl_46json_d0dd8d2f" */),
      cache: true
    },
    {
      key: "locale_pl_46json_fd460388",
      load: () => import("#nuxt-i18n/fd460388" /* webpackChunkName: "locale_pl_46json_fd460388" */),
      cache: true
    },
    {
      key: "locale_pl_46json_b184bfdf",
      load: () => import("#nuxt-i18n/b184bfdf" /* webpackChunkName: "locale_pl_46json_b184bfdf" */),
      cache: true
    },
    {
      key: "locale_pl_46json_d76964ce",
      load: () => import("#nuxt-i18n/d76964ce" /* webpackChunkName: "locale_pl_46json_d76964ce" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_fa3ab5c6",
      load: () => import("#nuxt-i18n/fa3ab5c6" /* webpackChunkName: "locale_ko_46json_fa3ab5c6" */),
      cache: true
    },
    {
      key: "locale_ko_46json_645d6b19",
      load: () => import("#nuxt-i18n/645d6b19" /* webpackChunkName: "locale_ko_46json_645d6b19" */),
      cache: true
    },
    {
      key: "locale_ko_46json_1f179648",
      load: () => import("#nuxt-i18n/1f179648" /* webpackChunkName: "locale_ko_46json_1f179648" */),
      cache: true
    },
    {
      key: "locale_ko_46json_186adce9",
      load: () => import("#nuxt-i18n/186adce9" /* webpackChunkName: "locale_ko_46json_186adce9" */),
      cache: true
    },
    {
      key: "locale_ko_46json_7f3d6b0e",
      load: () => import("#nuxt-i18n/7f3d6b0e" /* webpackChunkName: "locale_ko_46json_7f3d6b0e" */),
      cache: true
    },
    {
      key: "locale_ko_46json_671ae0b1",
      load: () => import("#nuxt-i18n/671ae0b1" /* webpackChunkName: "locale_ko_46json_671ae0b1" */),
      cache: true
    },
    {
      key: "locale_ko_46json_b827fb95",
      load: () => import("#nuxt-i18n/b827fb95" /* webpackChunkName: "locale_ko_46json_b827fb95" */),
      cache: true
    },
    {
      key: "locale_ko_46json_8c1cb4b9",
      load: () => import("#nuxt-i18n/8c1cb4b9" /* webpackChunkName: "locale_ko_46json_8c1cb4b9" */),
      cache: true
    },
    {
      key: "locale_ko_46json_89e587c2",
      load: () => import("#nuxt-i18n/89e587c2" /* webpackChunkName: "locale_ko_46json_89e587c2" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_2819a302",
      load: () => import("#nuxt-i18n/2819a302" /* webpackChunkName: "locale_uk_46json_2819a302" */),
      cache: true
    },
    {
      key: "locale_uk_46json_faa751dc",
      load: () => import("#nuxt-i18n/faa751dc" /* webpackChunkName: "locale_uk_46json_faa751dc" */),
      cache: true
    },
    {
      key: "locale_uk_46json_53844b84",
      load: () => import("#nuxt-i18n/53844b84" /* webpackChunkName: "locale_uk_46json_53844b84" */),
      cache: true
    },
    {
      key: "locale_uk_46json_dc079eab",
      load: () => import("#nuxt-i18n/dc079eab" /* webpackChunkName: "locale_uk_46json_dc079eab" */),
      cache: true
    },
    {
      key: "locale_uk_46json_0503f3f2",
      load: () => import("#nuxt-i18n/0503f3f2" /* webpackChunkName: "locale_uk_46json_0503f3f2" */),
      cache: true
    },
    {
      key: "locale_uk_46json_322e774c",
      load: () => import("#nuxt-i18n/322e774c" /* webpackChunkName: "locale_uk_46json_322e774c" */),
      cache: true
    },
    {
      key: "locale_uk_46json_faf73528",
      load: () => import("#nuxt-i18n/faf73528" /* webpackChunkName: "locale_uk_46json_faf73528" */),
      cache: true
    },
    {
      key: "locale_uk_46json_26b69873",
      load: () => import("#nuxt-i18n/26b69873" /* webpackChunkName: "locale_uk_46json_26b69873" */),
      cache: true
    },
    {
      key: "locale_uk_46json_1b7be385",
      load: () => import("#nuxt-i18n/1b7be385" /* webpackChunkName: "locale_uk_46json_1b7be385" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/31c4b838" /* webpackChunkName: "config_i18n_46config_46ts_31c4b838" */)
]
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined
  }
]

